import React, { useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App.jsx';
import './index.css';
import { I18nextProvider } from 'react-i18next';
import i18n from './i18n.js';
import { initializeLanguage } from './utils/languageRouting.js';
import { syncDocumentLanguage } from './utils/documentLanguage.js';

const initialLanguage = initializeLanguage(i18n, window.location.pathname, window.location.search);
syncDocumentLanguage(initialLanguage || i18n.language);

const LanguageInitializer = ({ children }) => {
  useEffect(() => {
    const handleLanguageChanged = (nextLanguage) => {
      syncDocumentLanguage(nextLanguage);
    };

    i18n.on('languageChanged', handleLanguageChanged);

    return () => {
      i18n.off('languageChanged', handleLanguageChanged);
    };
  }, []);

  return children;
};

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <I18nextProvider i18n={i18n}>
      <LanguageInitializer>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </LanguageInitializer>
    </I18nextProvider>
  </React.StrictMode>,
);
